import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b2bcfdf6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bcfdf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2bcfdf6')) {
      api.createRecord('b2bcfdf6', component.options)
    } else {
      api.reload('b2bcfdf6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b2bcfdf6&scoped=true", function () {
      api.rerender('b2bcfdf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/dangao/brandlist/index.vue"
export default component.exports